import Swal from "sweetalert2";

export const showToastNotification = (title, icon) => {
  let timerInterval;

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    icon: icon || "info",
    title: title || "Default Notification",
    showConfirmButton: false,
    timer: 4000,
    timerProgressBar: true,
    background: "#fff",
    customClass: {
      popup: "colored-toast",
    },
    didOpen: (toast) => {
      const swalPopup = toast;

      // Pause timer on hover
      swalPopup.addEventListener("mouseenter", () => {
        Swal.stopTimer();
      });

      // Resume timer on mouse leave
      swalPopup.addEventListener("mouseleave", () => {
        Swal.resumeTimer();
      });
    },
  });

  Toast.fire();
};
